import { FILTER_FEATURE } from "api/ApiPath";
import client from "api/client";
import { PartnerManagementRequestModel } from "api/repositories/partnerManagement/model/PartnerManagementRequestModel";
import { ListBaseApiResponseModel } from "app/based/baseApiModel/baseApiResponseModel/ListBaseApiResponseModel";
import { injectable } from "tsyringe";
// import { CarrierListRequestModel } from "./model/carrierList/CarrierListRequestModel";
import { PackageListRequestModel } from "./model/packageList/PackageListRequestModel";
import { PackageListResponseModel } from "./model/packageList/PackageListResponseModel";
import { PartnerListResponseModel } from "./model/partnerList/PartnerListResponseModel";
import { StoreListRequestModel } from "./model/storeList/StoreListRequestModel";
import { StoreListResponseModel } from "./model/storeList/StoreListResponseModel";
import { SupplierListRequestModel } from "./model/supplierList/SupplierListRequestModel";
import { SupplierListResponseModel } from "./model/supplierList/SupplierListResponseModel";

export interface IFilterFeatureRepository {
  getPackageList(
    params: PackageListRequestModel,
  ): Promise<ListBaseApiResponseModel<PackageListResponseModel>>;
  getSupplierList(
    params: SupplierListRequestModel,
  ): Promise<ListBaseApiResponseModel<SupplierListResponseModel>>;
  getPartnerList(
    params: PartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<PartnerListResponseModel>>;
  getStoreList(
    params: StoreListRequestModel,
  ): Promise<ListBaseApiResponseModel<StoreListResponseModel>>;
}

@injectable()
export class FilterFeatureImpl implements IFilterFeatureRepository {
  async getPackageList(
    params: PackageListRequestModel,
  ): Promise<ListBaseApiResponseModel<PackageListResponseModel>> {
    return await client?.get(FILTER_FEATURE.PACKAGE_LIST, {
      ...params,
      order: "price ASC",
    });
  }

  async getSupplierList(
    params: SupplierListRequestModel,
  ): Promise<ListBaseApiResponseModel<SupplierListResponseModel>> {
    return await client?.get(FILTER_FEATURE.SUPPLIER_LIST, params);
  }

  async getPartnerList(
    params: PartnerManagementRequestModel,
  ): Promise<ListBaseApiResponseModel<PartnerListResponseModel>> {
    return await client?.get(FILTER_FEATURE.PARTNER_LIST, params);
  }

  async getStoreList(
    params: StoreListRequestModel,
  ): Promise<ListBaseApiResponseModel<StoreListResponseModel>> {
    return await client?.get(FILTER_FEATURE.STORE_LIST, params);
  }
}
